import { render, staticRenderFns } from "./ApiKeyResources.vue?vue&type=template&id=3a242b82&scoped=true&"
import script from "./ApiKeyResources.vue?vue&type=script&lang=js&"
export * from "./ApiKeyResources.vue?vue&type=script&lang=js&"
import style0 from "./ApiKeyResources.vue?vue&type=style&index=0&id=3a242b82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a242b82",
  null
  
)

export default component.exports